module.exports = __webpack_public_path__ + "static/media/c-.e4f46516.png";